import { Typography, styled } from "@mui/material"
import { UserRole } from "../../api/generated"

export default styled(Typography, {
  shouldForwardProp: (prop) => !["rounded", "role"].includes(prop as string),
})<{ rounded?: boolean; randomColor: string }>(({ rounded = true, randomColor }) => ({
  alignSelf: "center",
  width: "24px",
  height: "24px",
  textAlign: "center",
  lineHeight: "24px",
  borderRadius: "100px",
  backgroundColor: randomColor,
  fontWeight: 500,
  fontSize: '12px',
  color: 'var(--white)',
  ...(rounded && { borderRadius: "100px" }),
}))